// libNN.ScrollDirectionClass.js 2024/03
// 2024/07 add threshold

import ScrollHelper from './_ScrollHelper.js'

class ScrollDirectionClass {
  constructor() {
    this.threshold = 80
    this.prev = 0
    this.scrollValue = 0

    let direction = this.direction
    Object.defineProperty(this, 'direction', {
        get: () => direction,
        set: newValue => {
            const oldValue = direction;
            direction = newValue;
            if(oldValue !== newValue) {
              // console.log('CHANGE DIRECTIOn', newValue, this)
              this.hold()
            }
        },
        configurable: true
    });

    let moved = this.moved
    Object.defineProperty(this, 'moved', {
        get: () => moved,
        set: newValue => {
            const oldValue = moved;
            moved = newValue;
            if(oldValue !== newValue && newValue) {
              document.querySelector('body').classList.toggle('is-scroll-up', this.direction)
              // console.log('MOVED', newValue, this.prev, this.direction, document.scrollingElement.scrollTop)
            }
        },
        configurable: true
    });

    new ScrollHelper(e => {
      this.direction = this.prev > document.documentElement.scrollTop
      this.moved = Math.abs(this.scrollValue - document.documentElement.scrollTop) > this.threshold
      this.prev = document.documentElement.scrollTop
      
    }, 1000 / 5)
  }
  hold() {
    this.scrollValue = document.documentElement.scrollTop
  }
}

// class ScrollDirectionClass {
//   constructor() {
//     this.prev = 0
//     new ScrollHelper(e => {
//       document.querySelector('body').classList.toggle('is-scroll-up', this.prev > document.documentElement.scrollTop)
//       this.prev = document.documentElement.scrollTop
//     }, 1000 / 5)
//   }
// }

export default ScrollDirectionClass;

